import { render } from "./TopNav.vue?vue&type=template&id=a5b89cfe&scoped=true"
import script from "./TopNav.vue?vue&type=script&lang=js"
export * from "./TopNav.vue?vue&type=script&lang=js"

import "./TopNav.vue?vue&type=style&index=0&id=a5b89cfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5b89cfe"]])

export default __exports__